import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyDate: {
		id: 'business-list.list-view.date-cell.empty-date',
		defaultMessage: 'None',
		description: 'Text to show when no date value is present on a date cell.',
	},
	errorTitle: {
		id: 'business-list.list-view.date-cell.error-title',
		defaultMessage: "We couldn't save the date value.",
		description: 'Error message informing the user that updating the field failed',
	},
	errorMessage: {
		id: 'business-list.list-view.date-cell.error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when save fails',
	},
	due: {
		id: 'date-with-urgency-indicator.due',
		defaultMessage: 'Due on {date}',
		description: 'Tooltip text shown when a date is due today or at a later date',
	},
	overdue: {
		id: 'date-with-urgency-indicator.overdue',
		defaultMessage: 'Overdue since {date}',
		description: 'Tooltip shown when a date is past X days. Eg: Overdue since 7 June 2024 UTC',
	},
});
